import { render, staticRenderFns } from "./ContinueWithoutMedicalOrderButton.vue?vue&type=template&id=58789b78&scoped=true"
import script from "./ContinueWithoutMedicalOrderButton.vue?vue&type=script&lang=js"
export * from "./ContinueWithoutMedicalOrderButton.vue?vue&type=script&lang=js"
import style0 from "./ContinueWithoutMedicalOrderButton.vue?vue&type=style&index=0&id=58789b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58789b78",
  null
  
)

export default component.exports